/**
 * React dependencies
 */

import React, { useContext } from 'react';
import { ModalContext } from '../Modal/ModalContext';
import { ContributorsContext } from './ContributorsContext';

import { authorShapeIcon } from '../.././img/icons';
import {
  handleContributorAuthorRoles,
  handleContributorImage,
  handleContributorTabAuthorRoles
} from '../utils/component-utils';
import isEmpty from 'lodash/isEmpty';

/**
 * Contributor
 *
 * A component to render a single Contributor
 *
 * @param {Object}  props
 * @param {Object}  props.item
 * @param {boolean} props.showMetadata
 */

const Contributor = ({ item, showMetadata }) => {
  const { onClickOpenModal } = useContext( ModalContext );
  const contributorsContext = useContext( ContributorsContext );

  const decodedTitle = decodeURIComponent( item.display );
  const getAuthor = ( item ) => {
    let authors = '';
    let str;

    // for audiobooks
    item?.authors?.forEach( ( author ) => {
      if ( author?.contribRoleCode === 'A' ) {
        authors += `${author.authorDisplay}, `;
        str = authors.replace( /,\s*$/, '' );
      }
    });
    // everything else
    if ( !str || str === '' ) {
      str = decodedTitle;
    }

    return str;
  };

  const getCoverImage = item?.uploadedImage?.url ? item.uploadedImage.url : handleContributorImage( item );
  let getAuthorRoles = null;
  if ( item.contribRoles ) {
    getAuthorRoles = handleContributorAuthorRoles( item, contributorsContext );
  } else if ( item.roles ) {
    getAuthorRoles = handleContributorTabAuthorRoles( item );
  } else if ( item.authorRoles ) {
    getAuthorRoles = item.authorRoles.join( ', ' );
  }

  const altText = contributorsContext.entry === 'manual' && item?.altTextManual && item?.altTextManual !== '' ? item.altTextManual : getAuthor( item );
  const authorInitials = ( item?.firstInitial ?? '' ) + ( item?.lastInitial ?? '' );
  const showAuthorInitialsOverlay = !item?.hasAuthorPhoto && isEmpty( item?.uploadedImage );

  return (
    <div className='contributor--inner'>
      <div className='image-wrapper flex aspect-[81/100] overflow-hidden relative'>
        <div className='api-image-wrapper flex w-full h-full'>
          <img
            className="api-image"
            src={ getCoverImage }
            alt={ altText }
            data-author-id={ item?.authorId }
            title={ decodedTitle }
          />
          { showAuthorInitialsOverlay && (
            <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>
              { authorShapeIcon }
              <span className='heading-1 m-0 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>{ authorInitials }</span>
            </div>
          ) }
        </div>
        <div className="overlay absolute top-0 bottom-0 left-0 right-0 opacity-0 transition-all ease-in-out duration-300"></div>
        <button
          aria-label={`View details for ${decodedTitle}`}
          className="text-12 uppercase py-17 px-11 bg-white view-details"
          onClick={ () => onClickOpenModal( item?.authorId, 'contributors' ) }
        >+ View Details</button>
      </div>

      { showMetadata && (
        <div className="contributor-details mt-16">
          { decodedTitle && (
            <p className="contributor-details__title paragraph-1 text-16 mt-0 mb-0"><strong>
              <span
                dangerouslySetInnerHTML={{
                  __html: decodedTitle
                }}
              />
            </strong></p>
          ) }

          { getAuthorRoles && (
            <p className="contributor-details__title paragraph-2 text-[0.9rem] my-0">{ getAuthorRoles }</p>
          ) }
        </div>
      ) }
    </div>

  );
};

export default Contributor;
